
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Testimonials',
  data() {
    return {
      width: window.innerWidth,
      currentIndex: 0,
    }
  },
  computed: {
    all() {
      return [
        {
          name: this.$t('landingMTClickbait.testimonials.reviews.review_1.name'),
          text: this.$t('landingMTClickbait.testimonials.reviews.review_1.review'),
        },
        {
          name: this.$t('landingMTClickbait.testimonials.reviews.review_2.name'),
          text: this.$t('landingMTClickbait.testimonials.reviews.review_2.review'),
        },
        {
          name: this.$t('landingMTClickbait.testimonials.reviews.review_3.name'),
          text: this.$t('landingMTClickbait.testimonials.reviews.review_3.review'),
        },
        {
          name: this.$t('landingMTClickbait.testimonials.reviews.review_4.name'),
          text: this.$t('landingMTClickbait.testimonials.reviews.review_4.review'),
        },
        {
          name: this.$t('landingMTClickbait.testimonials.reviews.review_5.name'),
          text: this.$t('landingMTClickbait.testimonials.reviews.review_5.review'),
        },
        {
          name: this.$t('landingMTClickbait.testimonials.reviews.review_6.name'),
          text: this.$t('landingMTClickbait.testimonials.reviews.review_6.review'),
        },
      ]
    },
    itemsToShow() {
      const w = this.width
      if (w >= 1440) return 3
      if (w >= 1024) return 3
      if (w >= 768) return 2
      return 1
    },
    visibleTestimonials() {
      return this.all.slice(this.currentIndex, this.currentIndex + this.itemsToShow)
    },
    totalPages() {
      return Math.max(1, Math.ceil(this.all.length / this.itemsToShow))
    },
    currentPage() {
      return Math.floor(this.currentIndex / this.itemsToShow)
    },
  },
  methods: {
    onResize() {
      this.width = window.innerWidth
    },
    clampIndex() {
      const max = Math.max(0, this.all.length - this.itemsToShow)
      if (this.currentIndex > max) this.currentIndex = max
    },
    goToPage(page: number) {
      this.currentIndex = Math.min(
        page * this.itemsToShow,
        Math.max(0, this.all.length - this.itemsToShow),
      )
    },
    next() {
      const nextIndex = this.currentIndex + this.itemsToShow
      if (nextIndex >= this.all.length) {
        this.currentIndex = Math.max(0, this.all.length - this.itemsToShow)
      } else {
        this.currentIndex = nextIndex
      }
    },
    prev() {
      const prevIndex = this.currentIndex - this.itemsToShow
      this.currentIndex = Math.max(0, prevIndex)
    },
  },
  mounted() {
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
  },
  unmounted() {
    window.removeEventListener('resize', this.onResize)
  },
  watch: {
    itemsToShow() {
      this.clampIndex()
    },
  },
})
